import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function AddMaterialButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.addMaterial")}</ActionButtonLayout>;

}

export default AddMaterialButtonLayout;

